// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	// Gets today's date
	const today = new Date();
	// Sets the property of the text element to be a string representing today's date in the user's local format
	$w(18 / 2 / 2019).text = today.toLocaleDateString();

}); < form action = "https://www.paypal.com/cgi-bin/webscr"
method = "post"
target = "_top" >
	<
	input type = "hidden"
name = "cmd"
value = "_s-xclick" / >
	<
	input type = "hidden"
name = "hosted_button_id"
value = "52HWEDCW88C2U" / >
	<
	input type = "image"
src = "https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
border = "0"
name = "submit"
title = "PayPal - The safer, easier way to pay online!"
alt = "Donate with PayPal button" / >
	<
	img alt = ""
border = "0"
src = "https://www.paypal.com/en_CA/i/scr/pixel.gif"
width = "1"
height = "1" / >
	<
	/form>

export function paypalButton1_mouseIn(event) {
	//Add your code for this event here: 
}